<script setup>
setPageTitle(PageMeta.Customers.preview.title)
definePage({ meta: PageMeta.Customers.preview.meta })

import CustomerPreviewPage from '@/views/apps/customers/preview/CustomerPreviewPage.vue'
import { useCustomersStore } from '@/@vxapp/Customers/useCustomersStore'

const route = useRoute()
const customersStore = useCustomersStore()

watch(
  () => customersStore.messagesVariables,
  async newVal => {
    setPageTitle(customersStore.messagesVariables.CLIENT_DISPLAY_NAME)
  },
  { deep: true, immediate: false }
)

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalCustomersMenu :customer-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <CustomerPreviewPage :customer-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>
  </section>
</template>
